// const baseUrl = process.env.NODE_ENV === "production" 
// ? 'http://localhost:2096/' 
// : 'http://localhost:2096';

// export default baseUrl;


// REACT_APP_API="https://campuspulse.umt.edu.pk:2096"
const baseUrl = process.env.NODE_ENV === "production" 
  ? 'https://campuspulse.umt.edu.pk' 
  : 'https://campuspulse.umt.edu.pk:2096';

  const apiCall = process.env.NODE_ENV === "production" 
  ? 'https://campuspulse.umt.edu.pk:2096' 
  : 'https://campuspulse.umt.edu.pk:2096';

module.exports = baseUrl;
module.exports = apiCall;


